import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: theme.maxContentWidth.regular,
    padding: [theme.marginBase * 3],
    backgroundColor: theme.colors.white,
    boxShadow: theme.boxShadow.base,
    borderRadius: theme.borderRadius.large,

    [theme.media.tablet]: {
      width: theme.maxContentWidth.reduced,
    },
    [theme.media.mobile]: {
      width: '100%',
    },
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.marginBase * 2,
  },
  title: {
    ...theme.fonts.label,
    textTransform: 'uppercase',
    color: theme.colors.inkSecondary,
  },
  iconStyle: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.blueAccessible,
  },
  logoContainer: {
    width: theme.marginBase * 4,
    height: theme.marginBase * 4,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.colors.blueMuted,
    alignItems: 'center',
    borderRadius: '50%',
  },
  childrenContainer: {
    padding: [0, theme.marginBase * 3],
  },
}));

interface Props {
  title: string;
  icon?: string;
  children?: React.ReactNode;
  className?: string;
}

export const Notification = ({ title, children, icon, className }: Props) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.container, className)}>
      <div className={classes.titleContainer}>
        <h3 className={classes.title}>{title}</h3>
        {icon && (
          <div className={classes.logoContainer}>
            <i className={classnames(icon, classes.iconStyle)} title="Logo" />
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
